import React, { FC } from "react";
import "./style.scss";

type PropType = {
  type?: "light" | "dark" | "red" | "green";
  action: string;
  price?: number;
  currency?: string;
  onClick?: () => void;
  disabled?: boolean;
  customClass?: boolean;
  onlyBtn?: boolean;
};

export const ActionBtn: FC<PropType> = ({
  type = "light",
  action,
  price,
  currency,
  onClick,
  disabled = false,
  customClass,
  onlyBtn,
}) => {
  const classNames = [
    "action-btn",
    `action-btn-${type}`,
    customClass && "action-btn-new",
    onlyBtn && "only-action-btn",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button disabled={disabled} onClick={onClick} className={classNames}>
      <p>{action}</p>
      {!!price && (
        <span>
          {price} {currency || ""}
        </span>
      )}
    </button>
  );
};
